var render = function render(){var _vm=this,_c=_vm._self._c;return (
    _vm.userRole !== 'order_viewer' &&
    _vm.userRole !== 'fin_monitor' &&
    _vm.userRole !== 'marketer' &&
    _vm.userRole !== 'price_editor'
  )?_c('div',{staticClass:"add-form__upload-file"},[_c('input',{staticClass:"add-form__upload-input",attrs:{"type":"file","accept":".zip","multiple":""},on:{"change":$event => _vm.inputHandler($event)}}),_c('div',{staticClass:"add-form__upload-block"},[_c('button',{staticClass:"header__actions-btn unload"},[_c('HeaderIcon',{attrs:{"name":"download"}}),_vm._v(" Загрузить файлы ")],1)])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }